import {createContext} from "react"

const ContextMain=createContext();

export default ContextMain;